export type GameLoopUpdate = {
  deltaMs: number;
  elapsedMs: number;
};

export class GameLoop {
  private frameHandle = 0;
  private previousTime = 0;
  private elapsedTime = 0;
  private running = false;

  public constructor(private readonly update: (frame: GameLoopUpdate) => void) {}

  public start(): void {
    if (this.running) {
      return;
    }

    this.running = true;
    this.previousTime = performance.now();
    this.frameHandle = requestAnimationFrame(this.frame);
  }

  public stop(): void {
    if (!this.running) {
      return;
    }

    this.running = false;
    cancelAnimationFrame(this.frameHandle);
  }

  private readonly frame = (time: number): void => {
    if (!this.running) {
      return;
    }

    const deltaMs = Math.min(100, Math.max(0, time - this.previousTime));
    this.previousTime = time;
    this.elapsedTime += deltaMs;

    this.update({
      deltaMs,
      elapsedMs: this.elapsedTime
    });

    this.frameHandle = requestAnimationFrame(this.frame);
  };
}
